@import "tailwindcss";

body {
  @apply bg-gray-900 text-gray-100;
}

/* ======================
   共通アニメーション
   ====================== */

/* グラデーションアニメーション */
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.animate-gradient {
  animation: gradient 6s ease infinite;
}

/* フェードイン */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animate-fade-in {
  animation: fade-in 0.2s ease-out;
}

/* スライドイン（上から） */
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slide-in {
  animation: slide-in 0.3s ease-out forwards;
}

/* スライドアップ */
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slide-up {
  animation: slide-up 0.3s ease-out forwards;
}

/* スライドアップ（フェードイン付き） */
@keyframes slide-up-fade-in {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.animate-slide-up-fade-in {
  animation: slide-up-fade-in 0.2s ease-out;
}

/* スライドアップ（中央配置用） */
@keyframes slide-up-center {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 30px));
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
.animate-slide-up-center {
  animation: slide-up-center 0.3s ease-out forwards;
}

/* ======================
   カスタムスクロールバー
   ====================== */

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #374151;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
